import client from '../../../core/services/client';

export const getCompanyInvitation = (invitation) => client.get('company_invites', { params: { invitation } })
  .then((response) => response.data);
